module.exports = __webpack_public_path__ + "static/media/logo_expanded.f01b26e5.svg";